import { render, staticRenderFns } from "./ScreenBack.vue?vue&type=template&id=7948032e&"
import script from "./ScreenBack.vue?vue&type=script&lang=js&"
export * from "./ScreenBack.vue?vue&type=script&lang=js&"
import style0 from "./ScreenBack.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports